import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { FLOOR_TYPES, WHATSAPP_URL } from '../data/content';
import { Overline } from './Overline';
export function FloorTypes() {
  return <section id="suelos" className="bg-cream py-24 lg:py-32" data-id="element-209" data-mp="2vxwj2du5wj2c">
      <div className="mx-auto max-w-content px-6 lg:px-10" data-id="element-210" data-mp="2vvjrd8ylquc3">
        <div className="max-w-3xl" data-id="element-211" data-mp="3009o10134cy2">
          <Overline data-id="element-212" data-mp="2zx5b9e9k08vs">Materiales</Overline>
          <h2 className="mt-6 font-serif text-[2.1rem] font-light leading-[1.1] text-ink sm:text-[2.8rem]" data-id="element-213" data-mp="3noarvvnbj575">
            Te ayudamos a elegir el suelo que realmente necesita tu vivienda
          </h2>
        </div>

        <div className="mt-16 grid gap-8 lg:grid-cols-3" data-id="element-214" data-mp="3eoxif2z72gmf">
          {FLOOR_TYPES.map(floor => <article key={floor.name} className="group flex h-full flex-col overflow-hidden rounded-3xl border border-ink/10 bg-white shadow-card transition-[transform,box-shadow] duration-300 ease-premium hover:-translate-y-1 hover:shadow-lift" data-id="element-215" data-mp="3jm5zf08lwem3">
              <div className="aspect-[4/3] w-full overflow-hidden" data-id="element-216" data-mp="294n5esv9y62o">
                <img src={floor.image} alt={`Detalle de suelo ${floor.name}`} className="h-full w-full object-cover transition-transform duration-500 ease-premium group-hover:scale-[1.03]" data-id="element-217" data-mp="246d9gg1q71g0" />
              </div>
              <div className="flex flex-1 flex-col p-8" data-id="element-218" data-mp="2e6maq8akrd29">
                <h3 className="font-serif text-2xl font-light text-ink" data-id="element-219" data-mp="2s397a9ym817n">{floor.name}</h3>
                <p className="mt-4 text-[13.5px] leading-relaxed text-stone-600" data-id="element-220" data-mp="2n5zlr5eck9p3">{floor.text}</p>
                <div className="mt-auto pt-7" data-id="element-221" data-mp="31ungj9gdcfdz">
                  <div className="border-t border-ink/10 pt-5" data-id="element-222" data-mp="31tc82wbzajgj">
                    <p className="text-[11px] uppercase tracking-overline text-walnut" data-id="element-223" data-mp="2ww2bmwq697j7">
                      Perfecto para
                    </p>
                    <p className="mt-2.5 text-[13px] leading-relaxed text-ink/80" data-id="element-224" data-mp="3asft45uph8xo">
                      {floor.perfect}
                    </p>
                  </div>
                </div>
              </div>
            </article>)}
        </div>

        <div className="mt-14 flex flex-col items-start gap-3 rounded-3xl bg-sand px-8 py-8 sm:flex-row sm:items-center sm:justify-between lg:px-10" data-id="element-225" data-mp="3iwjcxfwazvxb">
          <p className="font-serif text-xl font-light text-ink" data-id="element-226" data-mp="3slb2xiht065l">
            No sé cuál elegir, quiero asesoría.
          </p>
          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="group inline-flex items-center gap-2 rounded-full bg-ink px-7 py-3.5 text-[13px] font-medium tracking-wide text-cream transition-[background-color,box-shadow] duration-200 ease-premium hover:bg-charcoal hover:shadow-lift" data-id="element-227" data-mp="i0ifjd75k5a">
            Quiero asesoría gratuita
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-premium group-hover:translate-x-0.5" aria-hidden="true" data-id="element-228" data-mp="2c7tc44qpyp7o" />
          </a>
        </div>
      </div>
    </section>;
}